/* unplugin-vue-components disabled */import { render } from "./product_dynamic.vue?vue&type=template&id=652fe55f&scoped=true"
import script from "./product_dynamic.vue?vue&type=script&lang=js"
export * from "./product_dynamic.vue?vue&type=script&lang=js"

import "./product_dynamic.vue?vue&type=style&index=0&id=652fe55f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652fe55f"]])

export default __exports__